







import { Component } from 'vue-property-decorator'

import Field from './Field.vue'
import Counter from '@/components/common/Counter.vue'

@Component({
  components: { Counter }
})
export default class FieldNumber extends Field {

  get currentValue() {
    return parseInt(this.field.value, 10) || 0
  }

  beforeUpdateField(field, value) {
    this.updateField(field, value.toString())
  }
}
